<nav class="navbar navbar-expand vista-navbar">
  <div class="container-fluid">
    <!-- Brand -->
    <a class="navbar-brand logo-section" [routerLink]="UserName == null ? '' : '/home'">
      <img src="/Content/img/logo-home.png" alt="" width="24" height="24" />
      <div class="title">VISTA REV-UP <span class="app-version"> V{{ app_version }}</span> </div>
    </a>

    <!-- Nav items - always expanded (no toggler needed for desktop app) -->
    <div class="navbar-collapse">
      <ul class="navbar-nav me-auto">
        <li class="nav-item header-item">
          <a class="nav-link" [routerLink]="['/home']" routerLinkActive="active">
            <i class="bi bi-house header-icon"></i>Home
          </a>
        </li>

        <li class="nav-item header-item">
          <a class="nav-link" [class.disabled]="!permissionDataVisualisation" [routerLink]="['/data-visualisation']"
             routerLinkActive="active">
            <i class="bi bi-bar-chart-line header-icon"></i>Data Visualization
          </a>
        </li>

        <li class="nav-item header-item">
          <a class="nav-link" [class.disabled]="!permissionDataParameters" [routerLink]="['/data-parameters']" routerLinkActive="active">
            <i class="bi bi-sliders header-icon"></i>Data Parameters
          </a>
        </li>

        <li class="nav-item header-item">
          <a class="nav-link" [class.disabled]="!permissionSettings" [routerLink]="['/settings']" routerLinkActive="active">
            <i class="bi bi-gear header-icon"></i>Settings
          </a>
        </li>
      </ul>

      <ul class="navbar-nav ms-auto align-items-center">
        <li class="nav-item username">
          <span>{{ UserName }}</span>
        </li>

        <li class="nav-item">
          <div class="separator"></div>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle choose-market-btn" data-bs-toggle="dropdown" role="button" aria-haspopup="true"
             [attr.aria-expanded]="false">
            <span *ngIf="selectedMarket" class="white-text">{{selectedMarket?.marketCompanyName}}</span>
            <span *ngIf="selectedMarket == null" class="white-text">ALL</span>
            <i class="bi bi-chevron-down white-text" style="margin-left: 10px;"></i>
          </a>

          <ul class="dropdown-menu dropdown-menu-end">
            <li><a class="dropdown-item market-company-item" (click)="onselectMarketco(null)">ALL</a></li>
            <li>
              <a *ngFor="let mco of marketCompanies  | orderBy : 'marketCompanyName'"
                 class="dropdown-item market-company-item" (click)="onselectMarketco(mco)">{{ mco.marketCompanyName }}</a>
            </li>
          </ul>
        </li>

        <li class="nav-item">
          <a class="nav-link logout-section">
            <i class="bi bi-power" (click)="Logout()"></i>
          </a>
        </li>
      </ul>
    </div>

  </div>
</nav>
<!-- <div *ngIf="UserName != null">
  <router-outlet></router-outlet>
</div> -->

<div *ngIf="UserName == null">
  <div id="notfound">
    <div class="notfound">
      <div class="notfound-404">
        <h1>4<span></span>4</h1>
      </div>
      <h2>Oops! Page Not Be Found</h2>
      <p>User is not identified in VISTA, please contact administrator.</p>
    </div>
  </div>
</div>
